import { createSlice } from "@reduxjs/toolkit";
import { nanoid } from "@reduxjs/toolkit";

const reStructureInputFields = (arr) => {
  return arr.map((a) => {
    const id = nanoid();
    return { id, label: a, name: a, value: a };
  });
};

const initialState = {
  mappingFields: [],
  requiredFields: [],
  optionalFields: [],
};

export const feedMappingSlice = createSlice({
  name: "feedMapping",
  initialState,
  reducers: {
    resetFeedMapping: () => initialState,
    setMappingFields: (state, action) => {
      const { requiredFields, optionalFields } = action.payload;
      state.requiredFields = reStructureInputFields(requiredFields);
      state.optionalFields = reStructureInputFields(optionalFields);
    },
    setMappingFieldsForCatalog: (state, action) => {
      state.mappingFields = reStructureInputFields(action.payload);
    },
  },
});

export const {
  resetFeedMapping,
  setMappingFields,
  setMappingFieldsForCatalog,
} = feedMappingSlice.actions;

export default feedMappingSlice.reducer;

export const selectMappingFields = (state) => state.feedMapping.mappingFields;
export const selectRequiredFields = (state) => state.feedMapping.requiredFields;
export const selectOptionalFields = (state) => state.feedMapping.optionalFields;
